import { Button, IconPlus } from '@vtex/admin-ui'
import {
  BrandsSelector,
  CategoriesSelector,
  CollectionsSelector,
  ProductsSelector,
  SkuSelector,
} from 'ui'
import { SCOPE_OPTIONS } from '../../../../../ItemsView/typing'
import { styles } from './styles'
import { FormState, hasError } from '@vtex/admin-ui-form'

type Props = {
  name: string
  form: FormState
  option: SCOPE_OPTIONS
  onClick: () => void
}

const HeaderMap = {
  [SCOPE_OPTIONS.SKUS]: SkuSelector.Header,
  [SCOPE_OPTIONS.COLLECTIONS]: CollectionsSelector.Header,
  [SCOPE_OPTIONS.PRODUCTS]: ProductsSelector.Header,
  [SCOPE_OPTIONS.CATEGORIES]: CategoriesSelector.Header,
  [SCOPE_OPTIONS.BRANDS]: BrandsSelector.Header,
}

function HeaderComponent(props: { name: SCOPE_OPTIONS }) {
  const { name } = props

  if (!name) return null

  const Component = HeaderMap[name]

  if (!Component) return null

  return <Component {...(props as any)} />
}

export function EmptyChip(props: Props) {
  const { name, form, option, onClick } = props

  return (
    <div
      className={styles.chip}
      onClick={onClick}
      data-error={hasError(form, name)}
      data-testid={`empty-chip-${name}`}
    >
      <HeaderComponent name={option} />
      <Button
        className={styles.nonHoverable}
        variant="neutralTertiary"
        icon={<IconPlus />}
      />
    </div>
  )
}
